function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DepositTemplate = require('./deposit.template');
var PendingDepositTemplate = require('./deposit-polling.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var Deposit = /*#__PURE__*/function () {
  function Deposit(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Deposit);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.local_dev = (mod === null || mod === void 0 ? void 0 : mod.local_dev) || false;
    app.connection.on('saito-crypto-deposit-render-request', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.local_dev = (mod === null || mod === void 0 ? void 0 : mod.local_dev) || false;
              if (_this.local_dev) {
                console.info('Deposit overlay moves into local test mode...');
              }

              // Cache these to fill in the overlay
              _this.ticker = obj.ticker || _this.app.wallet.returnPreferredCryptoTicker();
              _this.title = obj.title || 'Deposit Saito';
              _this.address = obj.address || _this.app.wallet.returnCryptoAddressByTicker(_this.ticker);
              _this.desired_amount = obj.amount || null;
              _this.migration = obj.migration || false;
              _this.warning = obj.warning || null;
              _this.callback = obj.callback || null;
              _this.render();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('saito-crypto-deposit-poll-pending', function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (obj) {
        _this.ticker = obj.ticker || _this.app.wallet.returnPreferredCryptoTicker();
        _this.address = obj.address || _this.app.wallet.returnCryptoAddressByTicker(_this.ticker);
        _this.callback = obj.callback || null;
      }
      var ticker = _this.migration ? '' : _this.ticker;
      _this.overlay.show(PendingDepositTemplate(ticker));
      _this.pollPendingDeposit();
    });
    this.messages = ['this is taking a while', 'hang in there', 'it will come through eventually', 'please remain on the line'];
    this.gifs = ['https://media4.giphy.com/media/mlvseq9yvZhba/giphy.gif?cid=2dedbeb5qwxjlsbfbb6hoegrqhuuk3jyox9114xh67d5n26b&ep=v1_gifs_search&rid=giphy.gif&ct=g', 'https://media3.giphy.com/media/nR4L10XlJcSeQ/giphy.gif?cid=2dedbeb5qwxjlsbfbb6hoegrqhuuk3jyox9114xh67d5n26b&ep=v1_gifs_search&rid=giphy.gif&ct=g', 'https://media2.giphy.com/media/5i7umUqAOYYEw/giphy.gif?cid=2dedbeb5qwxjlsbfbb6hoegrqhuuk3jyox9114xh67d5n26b&ep=v1_gifs_search&rid=giphy.gif&ct=g', 'https://media4.giphy.com/media/ND6xkVPaj8tHO/giphy.gif?cid=2dedbeb5zv19d51h53z7kixbzxbyecof4okksa5gllpv0pxr&ep=v1_gifs_search&rid=giphy.gif&ct=g', 'https://media1.giphy.com/media/YBsd8wdchmxqg/giphy.gif?cid=2dedbeb5zv19d51h53z7kixbzxbyecof4okksa5gllpv0pxr&ep=v1_gifs_search&rid=giphy.gif&ct=g'];
  }
  return _createClass(Deposit, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var balance;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.overlay.show(DepositTemplate(this.app, this.mod, this));
              this.renderCrypto();
              if (!(this.ticker === 'SAITO')) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.app.wallet.getBalance();
            case 1:
              balance = _context2.v;
              if (Number(balance) == 0 && document.querySelector('.get-saito-tokens')) {
                this.app.modules.renderInto('.get-saito-tokens');
              }
            case 2:
              this.attachEvents();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelector('#saito-deposit-form .pubkey-container').onclick = function (e) {
        navigator.clipboard.writeText(_this2.address);
        var icon_element = document.querySelector('#saito-deposit-form .pubkey-container i');
        icon_element.classList.toggle('fa-copy');
        icon_element.classList.toggle('fa-check');
        setTimeout(function () {
          icon_element.classList.toggle('fa-copy');
          icon_element.classList.toggle('fa-check');
        }, 800);
      };
      if (document.getElementById('submit')) {
        document.getElementById('submit').onclick = function () {
          _this2.overlay.show(PendingDepositTemplate(_this2.ticker));
          _this2.pollPendingDeposit();
        };
      }
    }
  }, {
    key: "renderCrypto",
    value: function () {
      var _renderCrypto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var cryptomod, countEl, confEl, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              cryptomod = this.app.wallet.returnCryptoModuleByTicker(this.ticker);
              _t = Number;
              _context3.n = 1;
              return cryptomod.fetchBalance();
            case 1:
              this.balance = _t(_context3.v);
              if (cryptomod !== null && cryptomod !== void 0 && cryptomod.confirmations) {
                countEl = document.querySelector('#saito-deposit-form .network-confirmations-count');
                if (countEl) {
                  countEl.innerHTML = cryptomod.confirmations;
                }
              } else {
                confEl = document.querySelector('#saito-deposit-form .network-confirmations');
                if (confEl) {
                  confEl.style.display = 'none';
                }
              }
              console.log('GEN QR 1: ' + this.address);
              this.app.browser.generateQRCode(this.address, 'deposit-qrcode');
              console.log('GEN QR 2');
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log('Error rendering crypto header: ' + _t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function renderCrypto() {
        return _renderCrypto.apply(this, arguments);
      }
      return renderCrypto;
    }()
  }, {
    key: "pollPendingDeposit",
    value: function () {
      var _pollPendingDeposit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this3 = this;
        var cryptomod, new_balance, confs, ct, interval, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.overlay.blockClose();
              cryptomod = this.app.wallet.returnCryptoModuleByTicker(this.ticker);
              _t3 = Number;
              _context5.n = 1;
              return cryptomod.getAvailableBalance();
            case 1:
              new_balance = _t3(_context5.v);
              console.log('Crypto Deposit: poll pending deposit...., current/initial/desired balance: ', new_balance, this.balance, this.desired_amount);

              // Short circuit before starting the interval
              if (!this.desired_amount) {
                _context5.n = 2;
                break;
              }
              if (!(new_balance > (this === null || this === void 0 ? void 0 : this.desired_amount))) {
                _context5.n = 2;
                break;
              }
              this.overlay.remove();
              if (this.callback) {
                this.callback();
              }
              return _context5.a(2);
            case 2:
              confs = cryptomod.confirmations;
              ct = 0;
              interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var html;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return cryptomod.fetchBalance();
                    case 1:
                      _context4.n = 2;
                      return cryptomod.fetchPendingDeposits(function (res) {
                        if (res.length > 0) {
                          var pending = res.pop();
                          ct = pending.confirmations;
                          var amount = Number(pending.amount);
                          if (amount > 0) {
                            console.log("".concat(amount, " deposit pending (").concat(ct, "/").concat(confs, ")"));
                          }
                        }
                        if (_this3.local_dev) {
                          ct += 2;
                        }
                        if (document.querySelector('.saito-progress-meter')) {
                          document.querySelector('.saito-progress-meter .file-transfer-progress').style.width = "".concat(100 * ct / confs, "%");
                        }
                      });
                    case 2:
                      if (ct % 2 == 0 && ct > 0) {
                        html = "<div>".concat(_this3.messages[Math.floor(_this3.messages.length * Math.random())], "</div>");
                        html += "<img class=\"img-prev\" src=\"".concat(_this3.gifs[Math.floor(_this3.gifs.length * Math.random())], "\"/>");
                        document.querySelector('.saito-crypto-deposit-content').innerHTML = html;
                      }
                      new_balance = Number(cryptomod.balance);
                      console.log('Crypto Deposit: poll -- balance -- ', new_balance, _this3.balance);
                      if (_this3.local_dev && ct > 8) {
                        new_balance = 100000 * Math.random();
                        new_balance = Number(new_balance.toFixed(8));
                      }
                      if (new_balance > _this3.balance) {
                        clearInterval(interval);
                        _this3.overlay.remove();
                        if (_this3.callback) {
                          _this3.callback();
                        }
                      }
                    case 3:
                      return _context4.a(2);
                  }
                }, _callee4);
              })), 4250);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function pollPendingDeposit() {
        return _pollPendingDeposit.apply(this, arguments);
      }
      return pollPendingDeposit;
    }()
  }]);
}();
module.exports = Deposit;